import React from 'react';

const About: React.FC = () => {
  const aboutCards = [
    {
      icon: '⚔️',
      title: 'Warriors',
      description: 'We are a dedicated group of players committed to excellence in Last War. Our alliance values strategy, teamwork, and respect.',
    },
    {
      icon: '🤝',
      title: 'Community',
      description: 'KinkAsylum is more than just an alliance - we\'re a community. We support each other, share strategies, and grow together.',
    },
    {
      icon: '🎯',
      title: 'Goals',
      description: 'Our mission is to dominate the battlefield while maintaining a fun, inclusive environment for all members.',
    },
  ];

  return (
    <section id="about" className="section">
      <div className="container">
        <h2 className="section-title">About KinkAsylum</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
          {aboutCards.map((card, index) => (
            <div
              key={index}
              className="about-card bg-bg-card p-8 rounded-xl border border-border text-center transition-all duration-300 hover:-translate-y-1 hover:border-primary hover:shadow-glow"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="text-5xl mb-4">{card.icon}</div>
              <h3 className="font-orbitron text-2xl mb-4 text-primary-light">{card.title}</h3>
              <p className="text-text-secondary leading-relaxed">{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
